import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("constant", ["applymentStatusList"]),
    // 根据关键词显示对应的placeholder
    kwPlaceHolder() {
      return this.kwTypes.find(i => i.value === this.dataForm.kwType).placeholder;
    },
    // 排除DRAFT(待提交)申请状态列表
    applymentStatusExcludeDraftList() {
      return this.applymentStatusList.filter(item => item.value != "DRAFT");
    },
  },
  watch: {
    // 监测开始时间到结束时间的时间戳范围(毫秒)
    watchStartToEndMillisecondTimeRange(newValue, oldValue) {
      if (newValue) {
        this.dataForm.startTime = newValue[0];
        this.dataForm.endTime = newValue[1];
      } else {
        this.dataForm.startTime = undefined;
        this.dataForm.endTime = undefined;
      }
    },
    // 监测开始时间到结束时间的时间戳范围(秒)
    watchStartToEndSecondTimeRange(newValue, oldValue) {
      if (newValue) {
        this.dataForm.startTime = newValue[0] / 1000;
        this.dataForm.endTime = newValue[1] / 1000;
      } else {
        this.dataForm.startTime = undefined;
        this.dataForm.endTime = undefined;
      }
    },
    // 监测申请时间开始到结束时间的时间戳范围(毫秒)
    watchApplyStartToApplyEndMillisecondTimeRange(newValue, oldValue) {
      if (newValue) {
        this.dataForm.applyTimeStart = newValue[0];
        this.dataForm.applyTimeEnd = newValue[1];
      } else {
        this.dataForm.applyTimeStart = undefined;
        this.dataForm.applyTimeEnd = undefined;
      }
    },
  },
  methods: {},
};
